export default __webpack_public_path__ + "static/media/armoured-vehicale.c40e0034.png";